import React from "react";

//styles
import withStyles from "@material-ui/core/styles/withStyles";
import featuresStyle from "assets/jss/material-kit-pro-react/views/sectionsSections/featuresStyle.jsx";

// @material-ui/icons
import Face from "@material-ui/icons/Face";
import ThumbsUp from "@material-ui/icons/ThumbUp";

// core components
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import InfoArea from "components/InfoArea/InfoArea.jsx";

class SectionProof extends React.Component {
  render() {
    const { classes } = this.props;
    return (
      <div className={classes.section} style={{marginBottom:"34px"}}>
        <GridContainer>
            <GridItem xs={false} sm={false} md={2}>&nbsp;</GridItem>
            <GridItem xs={12} sm={8} md={8} style={{textAlign:"center", paddingTop:"30px"}}>
              <h2 className={classes.title}>Proof</h2>
              <h5 className={classes.description} style={{color:"#343434"}}>
                A 2016 Gallup Poll showed a ten point increase after a year of implementation
                in <span style={{color:"#DF8F43", fontWeight:"500"}}>student engagement</span>, &nbsp;
                <span style={{color:"#DF8F43", fontWeight:"500"}}>campus wide well-being</span>&nbsp;
                and <span style={{color:"#DF8F43", fontWeight:"500"}}>hope</span>.
              </h5>
            </GridItem>
        </GridContainer>
          
        <GridContainer style={{marginTop:"-30px"}}>
            <GridItem xs={false} sm={2} ></GridItem>
            <GridItem xs={12} sm={4} >
                <InfoArea
                  icon={Face}
                  description={
                    <span>
                      <p style={{color:'#232323', fontSize:"15px"}}>
                      All participating schools dramatically decreased student 
                      discipline referrals in number and in severity.
                      </p>
                    </span>
                  }
                  iconColor="success"
                />
              </GridItem>
            <GridItem xs={12} sm={4} >
                <InfoArea
                    icon={ThumbsUp}
                    description={
                    <span>
                        <p style={{color:'#232323', fontSize:"15px"}}>
                        Informal survey results showed a 95% approval rating from parents and students
                        and a 100% approval rating from teachers.

                        </p>
                    </span>
                    }
                    iconColor="success"
                />
            </GridItem>          
        </GridContainer>
           
      </div>
    );
  }
}

export default withStyles(featuresStyle)(SectionProof);



// WEBPACK FOOTER //
// ./src/views/LandingPage/Sections/SectionProof.jsx